import { useCallback, useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { toast } from "sonner";
import Az900Dashboard from "@/components/az900/Az900Dashboard";
import Az900Exam from "@/components/az900/Az900Exam";
import Az900Result from "@/components/az900/Az900Result";

export default function Az900() {
  const [view, setView] = useState("dashboard"); // dashboard | exam | result
  const [meta, setMeta] = useState(null);
  const [exam, setExam] = useState(null);
  const [result, setResult] = useState(null);
  const [history, setHistory] = useState(null);
  const [starting, setStarting] = useState(false);

  const loadDashboard = useCallback(async () => {
    try {
      const [b, h, a] = await Promise.all([
        api.get("/az900/blueprint"),
        api.get("/az900/history"),
        api.get("/az900/active"),
      ]);
      setMeta(b.data);
      setHistory(h.data);
      if (a.data.active) {
        setExam(a.data.active);
      }
    } catch (e) {
      toast.error(apiErr(e));
    }
  }, []);

  useEffect(() => {
    loadDashboard();
  }, [loadDashboard]);

  const startExam = async (mode) => {
    setStarting(true);
    try {
      const r = await api.post("/az900/start", { mode });
      setExam(r.data.exam);
      setResult(null);
      setView("exam");
    } catch (e) {
      toast.error(apiErr(e));
    } finally {
      setStarting(false);
    }
  };

  const resumeExam = () => setView("exam");

  const onSubmitted = (res) => {
    setResult(res);
    setExam(null);
    setView("result");
    loadDashboard();
  };

  const backToDashboard = () => {
    setView("dashboard");
    setResult(null);
    loadDashboard();
  };

  const openPastResult = async (attemptId) => {
    try {
      const r = await api.post("/az900/submit", { attempt_id: attemptId });
      setResult(r.data);
      setView("result");
    } catch (e) {
      toast.error(apiErr(e));
    }
  };

  if (view === "exam" && exam)
    return <Az900Exam exam={exam} onSubmitted={onSubmitted} onExit={backToDashboard} />;

  if (view === "result" && result)
    return <Az900Result result={result} onBack={backToDashboard} onRetake={() => startExam(result.mode)} />;

  return (
    <Az900Dashboard
      meta={meta}
      history={history}
      resumeExam={exam ? resumeExam : null}
      startExam={startExam}
      starting={starting}
      openResult={openPastResult}
    />
  );
}
